export function moneyUnits(value: string): bigint {
  if (!/^(0|[1-9]\d{0,17})(\.\d{1,6})?$/.test(value || ''))
    throw new Error('金额格式不正确，最多六位小数');
  const [whole, fraction = ''] = value.split('.');
  return BigInt(whole) * BigInt(1000000) + BigInt(fraction.padEnd(6, '0'));
}
export function validateAllocation(
  amount: string,
  allocations: { planUuid: string; amount: string }[],
) {
  if (moneyUnits(amount) <= BigInt(0)) throw new Error('回款金额必须大于零');
  const seen = new Set<string>();
  let total = BigInt(0);
  for (const row of allocations) {
    if (!row.planUuid || seen.has(row.planUuid))
      throw new Error('请选择计划，且不能重复分配');
    seen.add(row.planUuid);
    if (moneyUnits(row.amount) <= BigInt(0))
      throw new Error('计划分配金额必须大于零');
    total += moneyUnits(row.amount);
  }
  if (!allocations.length || total !== moneyUnits(amount))
    throw new Error('计划分配合计必须等于回款金额');
}
export const displayReceiptMoney = (value?: string | null) =>
  value == null ? '待同步' : value;
